import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MenuItem } from "./menuItem";
import { toggleLoginModal } from "../../state/modal";
import { useAppDispatch, useAppSelector } from "../../state/hooks";
import { loginSuccess, logout } from "../../state/auth";
import { jwtDecode } from "jwt-decode";
import { Magic } from 'magic-sdk';

const magicKey = process.env.REACT_APP_MAGIC_PUBLISHABLE_KEY;
const magic = magicKey ? new Magic(magicKey) : null;

const Header = () => {
  const [isMenuVisible, setMenuVisible] = useState(false);
  const toggleMenu = () => setMenuVisible((prev) => !prev);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const dispatch = useAppDispatch();
  const { isLoggedIn, nickname } = useAppSelector((state) => state.authSlice);
  const [token, setToken] = useState<string | null>(null);
  const [userName, setUserName] = useState<string | null>(null);
  const [isUserMenuVisible, setUserMenuVisible] = useState(false);
  const [userMenuTimer, setUserMenuTimer] = useState<any>(null);

  const handleUserMenuEnter = () => {
    clearTimeout(userMenuTimer);
    setUserMenuVisible(true);
  };

  const handleUserMenuLeave = () => {
    const newTimer = setTimeout(() => {
      setUserMenuVisible(false);
    }, 2000);
    setUserMenuTimer(newTimer);
  };


  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const storedToken = localStorage.getItem("token") || sessionStorage.getItem("token");
    if (storedToken && !isLoggedIn) {
        try {
            const decodedToken: { name: string, exp: number } = jwtDecode(storedToken);
            if (Date.now() < decodedToken.exp * 1000) {
                dispatch(loginSuccess(decodedToken.name));
            } else {
                localStorage.removeItem("token");
                sessionStorage.removeItem("token");
            }
        } catch (e) {
            console.error("Invalid token:", e);
            localStorage.removeItem("token");
            sessionStorage.removeItem("token");
        }
    }
  }, [dispatch, isLoggedIn]);

  useEffect(() => {
    const currentToken = localStorage.getItem("token") || sessionStorage.getItem("token");
    if (isLoggedIn) {
        setUserName(nickname);
    } else {
        setUserName(null);
    }
    setToken(currentToken);
  }, [isLoggedIn, nickname]);

  const handleLogout = async () => {
    if (magic) {
      try {
        await magic.user.logout();
      } catch (error) {
        console.error("Error logging out of wallet:", error);
      }
    }
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");
    dispatch(logout());
  };

  const menuItems = [
    {
      width: 324,
      to: "/",
      label: "Socials",
      subMenu: [
        {
          label: "Facebook",
          imgName: "facebook.png",
          to: "https://www.facebook.com/iPlayMore",
          size: 22,
        },
        {
          label: "Instagram",
          imgName: "instagram.png",
          to: "https://www.instagram.com/thunderthronewars/?theme=dark",
          size: 22,
        },
        {
          label: "LinkedIn",
          imgName: "linkedin.png",
          to: "https://www.linkedin.com/company/iplaymore/posts/?feedView=all",
          size: 22,
        },
        {
          label: "Youtube",
          imgName: "youtube.png",
          to: "https://www.youtube.com/@iPlayMore",
          size: 22,
        },
        // { label: "Discord", imgName: "discord.png", to: "/", size: 22 },
        {
          label: "X/Twitter",
          imgName: "twitter.png",
          to: "https://x.com/iplaymore",
          size: 22,
        },
        {
          label: "Twitch",
          imgName: "twitch.png",
          to: "https://www.twitch.tv/iPlayTHUNDER",
          size: 22,
        },
        {
          label: "Artstation",
          imgName: "artstation.png",
          to: "https://www.artstation.com/iplaymore",
          size: 22,
        },
      ],
    },
    {
      width: 202,
      to: "/",
      label: "THUNDER©",
      subMenu: [
        { label: "Novel", imgName: "novel.png", to: "/novel", size: 25 },
        {
          label: "Art & Music",
          imgName: "music.png",
          to: "/art-music",
          size: 29,
        },
      ],
    },
    {
      width: 202,
      to: "/",
      label: "Download",
      subMenu: [
        {
          label: "Prologue",
          imgName: "thunder-game.png",
          to: "/prologue",
          size: 35,
        },
        {
          label: "Twitch Tool",
          imgName: "twitch2.png",
          to: "/twitch-tool",
          size: 27,
        },
      ],
    },
    {
      width: 244,
      to: "/",
      label: "iPlayMore",
      subMenu: [
        {
          label: "Who we are",
          imgName: "iplaymore.png",
          to: "/iplaymore",
          size: 34,
        },
        {
          label: "Testimonials",
          imgName: "teammates.png",
          to: "/testimonials",
          size: 34,
        },
        {
          label: "Update Logs",
          imgName: "update-arrow.png",
          to: "/update-logs",
          size: 24,
        },
        // { label: "Video Playlist", imgName: "polygon.png", to: "/videos", size: 24 },
      ],
    },
  ];

  return (
    <>
      <div
        className={` shadow-header sticky top-0 z-[1505] flex w-full h-[34px] md:h-[51px] lg:h-[51px] bg-[#090909] items-center px-1 py-4 md:px-10 justify-between -mt-1`}
      >
        <div className="flex items-center gap-1 md:gap-4">
          <Link to="/iplaymore">
            <img
              alt="header-logo"
              src="assets/img/logo-sm.png"
              className="w-[75px] lg:w-[86px] h-[28px] lg:h-[32px]"
            />
          </Link>
          <Link to="/">
            <img
              alt="header-logo-left"
              src="assets/img/logo-left-sm.png"
              className="w-[140px] lg:w-[193px] h-[13px] lg:h-[18px]"
            />
          </Link>
        </div>
        <img
          alt="header-three-dot"
          src="assets/img/three-dot.png"
          className="block md:hidden w-[29px] pr-2 cursor-pointer"
          onClick={toggleMenu}
        />
        <div className="hidden md:flex items-center gap-4 lg:gap-8 xl:gap-11 text-[12px] xl:text-[18px] lg:pr-11">
          <Link to={"/"} className="hover:text-primary-hover cursor-pointer">
            Home
          </Link>
                    <Link to={"/marketplace"} className="hover:text-primary-hover cursor-pointer">
            Marketplace
          </Link>
          {menuItems.map((item) => (
            <MenuItem
              key={item.label}
              width={item.width}
              subMenu={item.subMenu}
              to={item.to}
            >
              {item.label}
            </MenuItem>
          ))}
          {token ? (
            <div
              className="relative flex items-center gap-[6px] cursor-pointer"
              onMouseEnter={handleUserMenuEnter}
              onMouseLeave={handleUserMenuLeave}
            >
              <p className="text-[#ED9B17] hover:text-primary-hover hover:underline underline-offset-4">{userName && userName.length > 6 ? `${userName.substring(0, 6)}....` : userName}</p>
              <img
                alt="header-sign-in"
                src="assets/img/menu-icons/sign-in.png"
                className={`w-[18px] h-[16px] transition-transform duration-200 ${isUserMenuVisible ? "-rotate-90" : ""}`}
              />
              {isUserMenuVisible && (
                <div className="absolute right-0 top-full mt-3 w-48">
                <div className="bg-[#090909] rounded-bl-[18px] rounded-br-[18px] py-2 shadow-lg">
                    <Link
                      to="/profile"
                      className="hover:text-primary-hover px-2 pb-[2px] flex justify-start items-center w-full h-[34px] text-white text-[13px]"
                    >

                      Account management
                    </Link>
                    <Link
                      to="/prologue"
                      className="hover:text-primary-hover px-2 pb-[2px] flex justify-start items-center w-full h-[34px] text-white text-[13px]"
                    >
                      Download Game
                    </Link>
                    <Link
                      to="/inventory"
                      className="hover:text-primary-hover px-2 pb-[2px] flex justify-start items-center w-full h-[34px] text-white text-[13px]"
                    >
                      Inventory
                    </Link>
                    <button
                      onClick={handleLogout}
                      className="hover:text-primary-hover px-2 pb-[2px] flex justify-start items-center w-full h-[34px] text-white text-[13px]"
                    >
                      Log Out
                    </button>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div
              className="flex items-center gap-1 cursor-pointer"
              onClick={() => dispatch(toggleLoginModal(true))}
            >
              <img
                alt="header-sign-in"
                src="assets/img/menu-icons/sign-in.png"
                className="w-[18px] h-[16px]"
              />
              <p className="text-[#ED9B17] hover:text-primary-hover">Sign In</p>
            </div>
          )}
        </div>
      </div>
      {isMenuVisible && isMobile && (
        <div className="fixed inset-0 bg-[black] flex flex-col items-center pt-10 z-[1499] px-1 mt-1">
          <Link
            to={"/"}
            className="flex items-center w-full h-[36px] justify-center bg-[#090909] border border-[#666666] mb-2"
          >
            Home
          </Link>
                    <Link
            to={"/marketplace"}
            className="flex items-center w-full h-[36px] justify-center bg-[#090909] border border-[#666666] my-2 hover:text-primary-hover cursor-pointer"
          >
            Marketplace
          </Link>
          {menuItems.map((item) => (
            <MenuItem
              key={item.label}
              width={item.width == 186 ? 301 : item.width}
              onClick={toggleMenu}
              subMenu={item.subMenu}
              mobile={true}
              to={item.to}
            >
              {item.label}
            </MenuItem>
          ))}
          {token ? (
            <>
              <Link
                to={"/profile"}
                onClick={toggleMenu}
                className="flex items-center w-full h-[36px] justify-center bg-[#090909] border border-[#666666] mb-2"
              >
                <img
                  alt="profile-icon"
                  src="assets/img/menu-icons/sign-in.png"
                  className="w-[22px] h-[22px] mr-2"
                />
                Profile
              </Link>
              <button
                onClick={() => {
                  handleLogout();
                  toggleMenu();
                }}
                className="flex items-center w-full h-[36px] justify-center bg-[#090909] border border-[#666666]"
              >
                <img
                  alt="sign-out-icon"
                  src="assets/img/menu-icons/sign-in-gray.png"
                  className="w-[22px] h-[22px] mr-2"
                />
                Sign out
              </button>
            </>
          ) : (
            <button
              onClick={() => {
                dispatch(toggleLoginModal(true));
                toggleMenu();
              }}
              className="flex items-center w-full h-[36px] justify-center bg-[#090909] border border-[#666666]"
            >
              Sign in
            </button>
          )}
        </div>
      )}
    </>
  );
};

export default Header;
